import React from 'react';
import { Redirect } from 'react-router-dom';
import paths from '../../../config/local/paths';

/** @returns {JSX.Element} */
export default function ViewGroupOffers() {
	return (
		<Redirect
			to={{
				pathname: paths.app.admin.offers.view,
				state: { vendorMode: 'group' },
			}}
		/>
	);
}
